var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('block-header'),_c('div',{staticClass:"cookie"},[_c('div',{staticClass:"cookie__text",domProps:{"innerHTML":_vm._s(_vm.settings.cookies_page_content)}})]),_c('block-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }